export default __webpack_public_path__ + "static/media/acm.2d74e273.png";